export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_weddingshower-4198a6910510d8c9af2e78672916bfd4.jpg";